import React, { useEffect, useState } from 'react';
import axios from '../Axiosinstance';
import { Card, CardContent, CardMedia, Typography, Grid, Modal, Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const CategoryStudentWise = () => {
    const [categories, setCategories] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [categoryCounts, setCategoryCounts] = useState({}); // To store the counts
  
    useEffect(() => {
      // Fetch categories from API
      axios.get('/categorys')
        .then(response => {
          const fetchedCategories = response.data;
          setCategories(fetchedCategories);
          
          // Fetch active registration count for each category
          fetchedCategories.forEach(category => {
            axios.get(`/registrationadvances/${category.id}/active-registrations/count`)
              .then(response => {
                setCategoryCounts(prevCounts => ({
                  ...prevCounts,
                  [category.id]: response.data  // Store count by category id
                }));
              })
              .catch(error => {
                console.error("Error fetching registration count!", error);
              });
          });
        })
        .catch(error => {
          console.error("There was an error fetching the data!", error);
        });
    }, []);
  
    const handleCardClick = (category) => {
      setSelectedCategory(category);
      setOpenModal(true);
  
      // Fetch student data based on category ID
      axios.get(`/registrationadvances/${category.id}/active-registrations`)
        .then(response => {
          const studentData = response.data; 
          setStudents(studentData); // Store directly in state
        })
        .catch(error => {
          console.error("Error fetching student data!", error);
        });
    };
  
    const handleCloseModal = () => {
      setOpenModal(false);
      setSelectedCategory(null);
      setStudents([]);
      setPage(0);
      setSearchTerm('');
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const filteredStudents = students.filter(student => 
      (student.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (student.fullname || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (student.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (student.phone || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (student.nric || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
  
    return (
      <>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: '5vh' }}
        >
          {categories.map((category) => (
            <Grid item xs={12} sm={6} md={2} key={category.id}>
              <Card 
                style={{ 
                  maxWidth: 220, 
                  margin: '0 auto', 
                  borderRadius: '12px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s',
                }} 
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                }}
                onClick={() => handleCardClick(category)}  // Handle card click
              >
                <CardMedia
                  component="img"
                  height="90"
                  image={category.url}  
                  alt={category.name}
                  style={{ borderRadius: '12px 12px 0 0' }}
                />
                <CardContent 
                  style={{ 
                    padding: '10px', 
                    textAlign: 'center',
                    backgroundColor: '#f8f8f8'
                  }}>
                  <Typography gutterBottom variant="subtitle1" component="div" style={{ fontWeight: 600 }}>
                    {category.name} - {categoryCounts[category.id] || 0} {/* Display count here */}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="student-modal-title"
        aria-describedby="student-modal-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 0,
            overflowY: 'auto',
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{ position: 'absolute', top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          {selectedCategory && (
            <>
              <Typography id="student-modal-title" variant="h4" component="h2" gutterBottom>
                Students in {selectedCategory.name}
              </Typography>

              <TextField
                label="Search"
                variant="outlined"
                fullWidth
                margin="normal"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      {/* <TableCell>Full Name</TableCell> */}
                      <TableCell>NRIC</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Gender</TableCell>
                      <TableCell>DOB</TableCell>
                      <TableCell>Designation</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Type</TableCell>
                      {/* <TableCell>Approved</TableCell>
                      <TableCell>Remarks</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredStudents.length > 0 ? (
                      filteredStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((student) => (
                        <TableRow key={student.id}>
                          <TableCell>{student.name}</TableCell>
                          {/* <TableCell>{student.fullname}</TableCell> */}
                          <TableCell>{student.nric}</TableCell>
                          <TableCell>{student.email}</TableCell>
                          <TableCell>{student.phone}</TableCell>
                          <TableCell>{student.gender}</TableCell>
                          <TableCell>{new Date(student.dob).toLocaleDateString()}</TableCell>
                          <TableCell>{student.designation}</TableCell>
                          <TableCell>{student.status}</TableCell>
                          <TableCell>{student.type}</TableCell>
                          {/* <TableCell>{student.approve}</TableCell>
                          <TableCell>{student.remarks || 'None'}</TableCell> */}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={12} align="center">No students found.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={filteredStudents.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ mt: 2 }}
              />
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};
